import React from 'react';
import styled from 'styled-components';
import {useParams} from 'react-router-dom';
import {
  useWorkflowQuery,
  useUpdateWorkflowSearchConditionMutation,
  useAllCollectedFormUrlsQuery,
} from 'api';
import {Checkbox} from 'components/antd';
import useClientUser from 'hooks/useClientUser';

export default () => {
  const {isMember} = useClientUser();
  const {poolId, workflowId} = useParams<{
    poolId: string;
    workflowId: string;
  }>();

  const {data: {workflow = {}, workflow: {searchCondition = {}} = {}} = {}} =
    useWorkflowQuery({
      variables: {uuid: workflowId},
      fetchPolicy: 'cache-and-network',
    });

  const {data: {allCollectedFormUrls: {collectedFormUrls = []} = {}} = {}} =
    useAllCollectedFormUrlsQuery({
      variables: {
        poolUuid: poolId,
      },
      fetchPolicy: 'cache-and-network',
      skip: !poolId,
    });

  const [updateWorkflowSearchCondition] =
    useUpdateWorkflowSearchConditionMutation({
      refetchQueries: ['workflowProspectPoolCountsByStatus'],
    });

  const isConditionUpdatable = React.useMemo(
    () => workflow?.status === 'draft',
    [workflow],
  );

  return (
    <Item>
      <Label>
        タグ連携
        <br />
        フォーム
      </Label>
      <CheckboxGroup
        value={searchCondition?.collectedFormUrls}
        disabled={!isConditionUpdatable || !isMember}
        onChange={(values: string[]) =>
          updateWorkflowSearchCondition({
            variables: {
              uuid: workflowId,
              attributes: {
                collectedFormUrls: values,
              },
            },
          })
        }>
        {collectedFormUrls.map((collectedFormUrl) => (
          <Checkbox value={collectedFormUrl.id} key={collectedFormUrl.id}>
            {collectedFormUrl.title}
          </Checkbox>
        ))}
      </CheckboxGroup>
    </Item>
  );
};

const Item = styled.div`
  display: flex;
  margin-bottom: 30px;
`;

const Label = styled.div`
  width: 115px;
  font-weight: 500;
  font-size: 14px;
`;

const CheckboxGroup = styled(Checkbox.Group)`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;

  & > * {
    padding: 0 !important;
    margin: 0 !important;
  }
  .ant-checkbox-wrapper {
    display: flex;
    align-items: center;
  }
  .ant-checkbox {
    top: 0;
  }
`;
